const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate objectComposeBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  let result = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values === undefined || !Array.isArray(values)) {
    return result;
  }
  for (let index = 0; index < values.length; index += 1) {
    const item = values[index];
    /* eslint-disable-next-line no-await-in-loop */
    const {
      key,
      value
    } = await evaluateSource(item, content, parentContentPath, transientContext, nativeFunctions);
    /* eslint-disable-next-line no-await-in-loop */
    const evaluatedKey = await evaluateSource(key, content, parentContentPath, transientContext, nativeFunctions);
    /* eslint-disable-next-line no-await-in-loop */
    const evaluatedValue = await evaluateSource(value, content, parentContentPath, transientContext, nativeFunctions);
    if (evaluatedKey !== undefined && evaluatedKey !== null && evaluatedValue !== undefined) {
      if (result === undefined) {
        result = {};
      }
      if (evaluatedValue === null) {
        delete result[evaluatedKey];
      } else {
        result[evaluatedKey] = evaluatedValue;
      }
    }
  }
  return result;
};
module.exports = {
  evaluate
};